'use client';
import { useState } from 'react';
import clsx from 'clsx';
import { Typography } from '@bgzt/ui';

import styles from './ShopReviewKeywords.module.css';

type Props = {
  keywords?: string[];
};

const MIN_KEYWORD_COUNT = 3;
export const ShopReviewKeywords = ({ keywords = [] }: Props) => {
  const [isShowAll, setIsShowAll] = useState(false);
  if (keywords.length < 1) return null;

  const displayedKeywords = isShowAll ? keywords : keywords.slice(0, MIN_KEYWORD_COUNT);
  const hasMoreKeywords = keywords.length > MIN_KEYWORD_COUNT;

  return (
    <ul className={styles.container}>
      {displayedKeywords.map((keyword) => (
        <li key={keyword} className={styles.item}>
          <Typography variant="C4" color="gray-700">
            {keyword}
          </Typography>
        </li>
      ))}
      {hasMoreKeywords && !isShowAll && (
        <li className={clsx(styles.item, styles.showAllButton)} onClick={() => setIsShowAll(true)}>
          <Typography variant="C4" color="gray-700">
            +{keywords.length - MIN_KEYWORD_COUNT}
          </Typography>
        </li>
      )}
    </ul>
  );
};
